namespace GeniuzPOS.Administration {
    export interface PsFuncLevelRow {
        Id?: number;
        FunLevel?: number;
        FunLevelName?: string;
    }

    export namespace PsFuncLevelRow {
        export const idProperty = 'FunLevel';
        export const nameProperty = 'FunLevelName';
        export const localTextPrefix = 'Administration.PsFuncLevel';
        export const lookupKey = 'Administration.PsFuncLevel';

        export function getLookup(): Q.Lookup<PsFuncLevelRow> {
            return Q.getLookup<PsFuncLevelRow>('Administration.PsFuncLevel');
        }
        export const deletePermission = '1POSBASE:โปรไฟล์ของกิจการ:โปรไฟล์หลัก:Modify';
        export const insertPermission = '1POSBASE:โปรไฟล์ของกิจการ:โปรไฟล์หลัก:Modify';
        export const readPermission = '1POSBASE:โปรไฟล์ของกิจการ:โปรไฟล์หลัก:View';
        export const updatePermission = '1POSBASE:โปรไฟล์ของกิจการ:โปรไฟล์หลัก:Modify';

        export declare const enum Fields {
            Id = "Id",
            FunLevel = "FunLevel",
            FunLevelName = "FunLevelName"
        }
    }
}
